export default __webpack_public_path__ + "static/media/wasp-header.98cd23ad.jpg";